// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2k1cq","signatureButtonsRight":"ModalSign_signatureButtonsRight__31ida"};